export const TAG_TYPES = ['light', 'gray', 'dark', 'success', 'warn', 'error', 'update', 'attention', 'disabled', 'red', 'orange', 'yellow', 'green', 'teal', 'purple', 'themeable'];
export const TAG_SIZES = ['large', 'regular', 'small'];
export const TAG_FAMILIES = ['bold', 'soft'];